export default __webpack_public_path__ + "static/media/periodic-table-screen.8d787153.webp";